module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Get Paid More and Promoted Faster")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "CSS_1.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "d14e255"
    }
  }, [_c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_14"
    }
  }, [_c('span', {
    attrs: {
      "id": "d14e258"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('h1', {
    attrs: {
      "id": "d7e71714"
    }
  }, [_vm._v("Introduction: "), _c('br'), _vm._v(" Taking Charge of Your  "), _c('br'), _vm._v(" Career and Your Future ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e73014"
    }
  }, [_c('br'), _c('b', [_vm._v("T")]), _vm._v("his is a wonderful time in human history to be alive. There have never been more opportunities and possibilities for ambitious people to achieve their career and life goals than exist today.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e74814"
    }
  }, [_vm._v("Your responsibility to yourself and your world is to take full advantage of the doors opening all around you. Your duty is to participate with all your talents and abilities in what many economists are calling “the Golden Age of mankind.” This book will show you how to do it.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e77114"
    }
  }, [_vm._v("In the coming pages, you will learn a series of practical, proven, simple, and effective ways to get paid more money for what you do. You will learn how to get promoted faster to higher levels of authority and responsibility. You will learn how to supercharge your career and put yourself onto the fast track at work.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e79414"
    }
  }, [_vm._v("These methods and techniques are used by the highest paid and most successful people in our society. When you begin to practice them yourself, you  will put your foot onto the accelerator of your life and begin racing ahead in your career. You will make more progress in the next couple of years than the average person makes in ten or twenty years of just plodding along with the crowd.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_15"
    }
  }, [_c('span', {
    attrs: {
      "id": "d14e278"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e82815"
    }
  }, [_vm._v("We have moved from an era of lifelong employment to an era of lifelong employability. This means that from now on, you are completely responsible for every part of your work and personal life. One of the biggest mistakes you can ever make is to think that you work for anyone but yourself. No matter who signs your paycheck, you are always your own boss. You are always self-employed. In the long run, you determine how much you get paid, how fast you get promoted, and everything else that happens to you. You are responsible.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e87115"
    }
  }, [_vm._v("The top 3 percent of Americans in terms of pay and promotion view themselves as self-employed, no matter where they work or whom they work for. This attitude of self-employment, of taking complete responsibility for results, makes them more valuable to their companies and to themselves. As a result, more doors open for them. They get paid more and promoted faster.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e90015"
    }
  }, [_vm._v("From now on, see yourself as the president of a company with one employee—yourself. See yourself as responsible for selling one product into a competitive marketplace—your personal services. See your- self as a consultant to your existing company who is determined to justify the amount you are paid every hour of every day.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e93016"
    }
  }, [_vm._v("Then, begin implementing the twenty-one great ways to get paid more and promoted faster that all fast-trackers use to move ahead more rapidly in their careers. You will never look back.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b9f920f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Introduction.vue
// module id = 75
// module chunks = 0